// 引入公共模块
import { 
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() {
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
    this.intelligentServiceTabHandler(); // 智能服务Tab
    this.skillLibraryTabHandler(); // 技能库Tab
  },
  intelligentServiceTabHandler() {
    $('.intelligent-service-tab-item').on('mouseenter', function(e){
       // 阻止默认的点击行为
        e.preventDefault();
        const $this = $(this);
        const tag = $this.attr('data-tag')

        // 1. 切换tab激活态
        $this.addClass('active').siblings().removeClass('active');

        // 2. 根据下标，给对应内容项加active，其他移除
        $('.intelligent-service-panel').removeClass('active');
        $(`.intelligent-service-panel[data-tag="${tag}"]`).addClass('active');
    })
  }, 
  skillLibraryTabHandler() {
    $('.skill-library-tab').on('mouseenter', function(e){
       // 阻止默认的点击行为
        e.preventDefault();
        const $this = $(this);
        const tag = $this.attr('data-tag')

        // 1. 切换tab激活态
        $this.addClass('active').siblings().removeClass('active');

        // 2. 根据下标，给对应内容项加active，其他移除
        $('.skill-library-panel').removeClass('active');
        $(`.skill-library-panel[data-tag="${tag}"]`).addClass('active');
    })
  }

};

// 文档加载后初始化
$(function () {
  App.init();
});
